import { getSignedUrl } from "../services/images.service";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "./queryKeys";
import { INTERVAL } from "../../../constants/clientTime";

export const useGetMediaImageSignedUrl = (
  fileName: string,
  fileSize: "small" | "large"
) => {
  return useQuery({
    queryKey: [QueryKeys.SignedUrl, fileName],
    queryFn: () => getSignedUrl([fileName], fileSize),
    staleTime: INTERVAL.WEEK,
    enabled: !!fileName,
  });
};
